import { useToggle } from 'admin';
import { useApiInspectionsV1CompaniesList } from 'api';
import { useMemo, useState } from 'react';
import { DataGrid, Drawer, Page, Section } from 'ui';

import { InspectorMutate } from '../../components/InspectorMutate/InspectorMutate';
import type { SelectedInspector } from '../../types';
import { extractInspectorsFromCompanies } from '../../utils/extractInspectorsFromCompanies';
import { columns } from './columns';
export const InspectorList = () => {
  const { data, isLoading } = useApiInspectionsV1CompaniesList();

  const { open, isOpen, close } = useToggle();
  const [selectedInspector, setSelectedInspector] = useState<SelectedInspector | null>(null);

  const inspectors = useMemo(
    () =>
      data?.results ? extractInspectorsFromCompanies(data.results).sort((a, b) => a.name.localeCompare(b.name)) : [],
    [data?.results]
  );

  return (
    <Page>
      <Drawer open={isOpen} anchor="right">
        {selectedInspector ? (
          <InspectorMutate
            company={selectedInspector.company}
            key={selectedInspector.id} // different components at same position state reset https://react.dev/learn/preserving-and-resetting-state#different-components-at-the-same-position-reset-state
            action="edit"
            inspector={{
              company: selectedInspector.company.id,
              email: selectedInspector.email,
              id: selectedInspector.id,
              is_active: selectedInspector.is_active,
              name: selectedInspector.name,
              phone_number: selectedInspector.phone_number,
            }}
            onSave={close}
            onClose={close}
          />
        ) : null}
      </Drawer>
      <Section title="Inspectors">
        <DataGrid<SelectedInspector>
          loading={isLoading}
          rows={inspectors}
          disableColumnMenu
          showColumnVerticalBorder
          showCellVerticalBorder
          autoHeight
          columns={columns}
          onRowClick={(params) => {
            setSelectedInspector(params.row);
            open();
          }}
        />
      </Section>
    </Page>
  );
};
